import { Mail, Phone, MapPin, User, CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import JobAttachments from "@/components/JobAttachments";
import { Empty } from "@/components/bedrijf/Empty";
import { BEDRIJF_STATUS_LABEL } from "@/lib/offerteOptions";

const FIELDS = [
  ["type", "Type"], ["breedte", "Breedte"], ["hoogte", "Hoogte"], ["aantal", "Aantal"],
  ["kleur_binnen", "Kleur binnen"], ["kleur_buiten", "Kleur buiten"], ["materiaal", "Materiaal"],
  ["verdeling", "Verdeling"], ["onderverdeling", "Onderverdeling"], ["glaskeuze", "Glas"],
  ["beglazing", "Beglazing"], ["ventilatie", "Ventilatie"], ["rolluik", "Rolluik"],
];

export function OntvangenOffertes({ offertes, userId, onSetStatus }) {
  return (
    <div className="space-y-4">
      {offertes.length === 0 && <Empty text="Je hebt nog geen offerteaanvragen ontvangen." />}
      {offertes.map((o) => {
        const myStatus = (o.bedrijf_status || {})[userId] || "open";
        return (
        <div key={o.id} data-testid="ontvangen-offerte-card" className="bg-white border border-slate-200 rounded-md p-5">
          <div className="flex flex-wrap items-center gap-4 mb-4 pb-4 border-b border-slate-100">
            <span className="flex items-center gap-1.5 text-sm font-semibold text-slate-900"><User className="w-4 h-4 text-orange-500" /> {o.naam}</span>
            <a href={`mailto:${o.email}`} className="flex items-center gap-1.5 text-sm text-slate-600 hover:text-orange-600"><Mail className="w-4 h-4" /> {o.email}</a>
            <a href={`tel:${o.telefoon}`} className="flex items-center gap-1.5 text-sm text-slate-600 hover:text-orange-600"><Phone className="w-4 h-4" /> {o.telefoon}</a>
            <span className="flex items-center gap-1.5 text-sm text-slate-600"><MapPin className="w-4 h-4" /> {o.adres_straat}, {o.adres_postcode} {o.adres_gemeente}</span>
            <span className="text-xs font-bold uppercase tracking-wide bg-slate-100 px-2 py-0.5 rounded-sm">{o.type_klant}</span>
          </div>
          {(o.werf_straat || o.werf_gemeente) && (
            <p className="text-xs text-slate-500 mb-3">Werfadres: {o.werf_straat} {o.werf_postcode} {o.werf_gemeente}</p>
          )}
          <div className="space-y-3">
            {(o.elementen || []).map((el, i) => (
              <div key={`${el.type || "el"}-${i}`} className="border border-slate-200 rounded-sm p-3">
                <p className="font-display font-bold text-slate-950 mb-2">Element {i + 1}</p>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-1 text-xs">
                  {FIELDS.map(([k, lbl]) => (
                    el[k] ? <span key={k} className="text-slate-600"><span className="text-slate-400">{lbl}:</span> <span className="font-semibold text-slate-800">{el[k]}</span></span> : null
                  ))}
                </div>
                {el.opmerkingen && <p className="text-xs text-slate-500 mt-2">Opmerking: {el.opmerkingen}</p>}
              </div>
            ))}
          </div>
          {o.bijlagen?.length > 0 && (
            <div className="mt-4 pt-4 border-t border-slate-100">
              <p className="text-xs font-bold text-slate-700 mb-2">Bijlagen van de aanvrager</p>
              <JobAttachments bijlagen={o.bijlagen} />
            </div>
          )}
          <div className="mt-4 pt-4 border-t border-slate-100 flex flex-wrap items-center gap-3">
            <span className="text-sm text-slate-500">Status:</span>
            <span data-testid="ontvangen-status" className={`text-xs font-bold px-2.5 py-1 rounded-sm ${myStatus === "offerte_verstuurd" ? "bg-green-100 text-green-700" : myStatus === "niet_geinteresseerd" ? "bg-slate-200 text-slate-600" : "bg-amber-100 text-amber-700"}`}>
              {BEDRIJF_STATUS_LABEL[myStatus]}
            </span>
            <div className="flex gap-2 ml-auto">
              <Button data-testid="mark-offerte-verstuurd-btn" onClick={() => onSetStatus(o.id, "offerte_verstuurd")}
                disabled={myStatus === "offerte_verstuurd"} size="sm"
                className="bg-green-600 hover:bg-green-700 text-white rounded-sm font-semibold">
                <CheckCircle2 className="w-4 h-4 mr-1.5" /> Offerte verstuurd
              </Button>
              <Button data-testid="mark-niet-geinteresseerd-btn" onClick={() => onSetStatus(o.id, "niet_geinteresseerd")}
                disabled={myStatus === "niet_geinteresseerd"} variant="outline" size="sm"
                className="rounded-sm font-semibold border-slate-300 text-slate-600 hover:bg-slate-50">
                <XCircle className="w-4 h-4 mr-1.5" /> Niet geïnteresseerd
              </Button>
            </div>
          </div>
        </div>
        );
      })}
    </div>
  );
}
